import React, { Component } from 'react'

import img1 from '../../../static/images/online-shop-banner.jpg'
// import imgTop from '../../../static/images/pos-banner-top.png'
// import product1 from '../../../static/images/product-1.png'
// import product2 from '../../../static/images/product-2.png'
import product3 from '../../../static/images/product-3.png'
// import product4 from '../../../static/images/product-4.png'
// import product5 from '../../../static/images/product-5.png'
// import product6 from '../../../static/images/product-6.png'
// import product7 from '../../../static/images/product-7.png'
// import product8 from '../../../static/images/product-8.png'

// import analysis1 from '../../../static/images/analysis1.png'
// import memberTop from '../../../static/images/member-top.png'
// import member1 from '../../../static/images/member1.png'
// import serviceBanner from '../../../static/images/case-banner.png'

// import unattended1 from '../../../static/images/unattended1.png'

// import step1 from '../../../static/images/step1.png'
// import more1 from '../../../static/images/more-member1.png'

import advantage2 from '../../../static/images/advantage2.png'
import advantage3 from '../../../static/images/advantage3.png'
import advantage4 from '../../../static/images/advantage4.png'
import advantage5 from '../../../static/images/advantage5.png'

// import intelligent1 from '../../../static/images/intelligent1.png'



import './index.less';

class OnlineShop extends Component {
    state = {
        iframeHeight: 600,
        customerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
        componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'online-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }
    onEvents() { }
    render() {
        const { iframeHeight } = this.state
        return (
             <div style={{ width: '100%' }}>
                 <iframe 
                 title="online-static"
                 src={`${process.env.PUBLIC_URL}/static/onlineShop/onlineShop.html`}
                style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>
            // <div className="product_container unattended-container online-container">
            //     <div className="top-home-carousel">
            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-title">悦喵AI线上商城</div>
            //                     <div className="banner-top-tips">真正实现用户支付和会员、线上和线下无缝连接的商户小程序，更好的帮助门店销售业绩增长。</div>
            //                     <div className="banner-top-tips"><span className="dot"></span>精细化经营会员</div>
            //                     <div className="banner-top-tips"><span className="dot"></span>获取线上流量</div>
            //                     <div className="banner-top-btn">了解体验</div>
            //                 </div>

            //             </div>

            //         </div>
            //     </div>

            //     <div className="common-block-home advantage-common-block-home">

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">线上线下一体化会员</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>线上线下会员一体化</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>会员余额、积分、优惠券、折扣优惠等全线打通</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>顾客一张会员卡通用</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>门店一个后台是实现一体化管理和运营</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>同时多渠道构建门店的自有会员体系</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">小程序直播，线上带货</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>支持微信官方小程序直播，过直播组件</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>可以在小程序中实现直播互动与商品销售的闭环</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>提升消费者购物体验</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>通过直播引导会员开卡、领券等</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>实现自有体系的会员拉新，同时提高门店收益</div>
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">商城装修</div>
            //                     <div className="advantage-detail-left-tips">
            //                         <div>01、丰富的装修模板</div>
            //                         <div className="desc">多套装修模板可选，操作简单；功能模块随意点选，装修更便捷</div>
            //                     </div>
            //                     <div className="advantage-detail-left-tips">
            //                         <div>02、多种功能按需添加</div>
            //                         <div className="desc">轮播广告、商品模块、海报、促销等多种装修组件，随意搭配，满足个性化需求。</div>
            //                     </div>
            //                     <div className="advantage-detail-left-tips">
            //                         <div>03、支持千店千面</div>
            //                         <div className="desc">不同门店销售不同商品、支持个性化门店首页、支持千店千面，满足多业态需求</div>
            //                     </div>
                               
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage3} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">支持多店版小程序</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>一个小程序支持多门店切换、多门店下单</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>各个门店自己配送、门店库存自动扣减</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>解决多门店的订单、库存、配送等问题</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>让多门店经营更简单</div>
            //                 </div>
            //             </div>
            //         </div>

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">对接配送平台，无忧配送</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>我们的小程序，支持自配送</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>同时对接了顺丰同城、美团、达送和闪送四个即时配送平台</div>
            //                     <div className="advantage-detail-left-tips"><span className="tips-icon"></span>让到家业务无忧</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage5} alt="" />
            //                 </div>
            //             </div>
            //         </div>

            //         <div className="advantage-detail" style={{background:'#fff'}}>
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">营销功能</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">促销活动：</span>单品促销、单品满减、买A赠B、奇偶促销、整单优惠等多种促销活动</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">限时秒杀：</span>秒杀活动可提前预热，限时抢购，提高顾客的活跃度。</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">优惠券：</span>线上线下优惠券同步使用，方便高效。</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">新人有礼：</span>新会员送积分、优惠券，促进消费。</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">充值有礼：</span>会员充值、充值有礼，提前蓄客，增加营业额。</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">精准营销：</span>给指定会员发送优惠券，精准营销。</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">场景营销：</span>会员生日赠积分、优惠券，客情关怀，提高顾客忠诚度。</div>
            //                     <div className="advantage-detail-left-tips color"><span className="tips-title">积分营销：</span>可按消费金额积分，支持积分支付抵扣。</div>
            //                 </div>
            //             </div>

            //         </div>

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">经营分析</div>
            //                     <div className="advantage-detail-left-tips">
            //                         <div>01、线上线下一体化</div>
            //                         <div className="desc">线上商城与收银系统无缝对接，会员、商品、订单等经营数据同步，便于管理。</div>
            //                     </div>
            //                     <div className="advantage-detail-left-tips">
            //                         <div>02、营业数据可视化</div>
            //                         <div className="desc">多维度数据记录，实时查看店铺运营情况，为门店经营提供可靠的数据支持和营销导向。</div>
            //                     </div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage3} alt="" />
            //                 </div>
            //             </div>

            //         </div>
                    

            //     </div>

            //     <div className="common-block-home product-page customer-page">
            //         <div className="common-block-home-title">你的同行都在使用</div>
            //         <div className="common-block-product common-customer">
            //             {
            //                 customerList && customerList.map((item) => (
            //                     <div className="customer-detail-img">
            //                         <img className="img-style" src={item.img} alt="" />
            //                     </div>
            //                 ))
            //             }

            //         </div>
            //     </div>

               

            // </div >
        )
    }
}


export default OnlineShop